/* SneakBoutik : fiche produit (galerie, pointures, ajout au panier Shopify). Reprise de la maquette. */
(() => {
'use strict';
const start = () => {
const {
  normalize, ALL, ALL_SIZES, fmt, sizeLabel, isPromo, discount, imgUrl, escapeHtml, titleCase, cart, toggleWish,
  syncWishButtons, renderCard, revealOnLoad, toast, openPanel, hasFreeShipping, readJson,
} = window.SBX;
const S = window.SB.settings;
const $ = (id) => document.getElementById(id);
const product = normalize(readJson('sb-product'));

// ---------- Fil d'Ariane et en-tête du produit ----------
$('bc-brand').textContent = titleCase(product.brand);
$('bc-brand').href = `${window.SB.root}?q=${encodeURIComponent(product.brand.toLowerCase())}#catalogue`;
$('bc-name').textContent = product.name;
$('brand').textContent = product.brand;
$('name').textContent = product.name;
$('price').textContent = fmt.format(product.price);
$('free-ship').hidden = !hasFreeShipping(product);
if (isPromo(product)) {
  $('price').classList.add('is-promo');
  $('was').textContent = fmt.format(product.compareAt);
  $('off').textContent = `-${discount(product)}%`;
} else {
  $('promo-timer').remove();
  $('was').hidden = true;
  $('off').hidden = true;
}

// ---------- Rareté ----------
const VARIANTS = product.variantList ?? [];
const OPTIONS = (product.optionsList ?? []).filter((o) => !(o.values.length === 1 && o.values[0] === 'Default Title'));
const STOCK = VARIANTS.filter((v) => v.available).length;
const scarcity = {
  0: ['Épuisé', 'Cette paire a trouvé preneur. Ajoute-la à tes favoris, on ne sait jamais.'],
  1: ['Dernière paire disponible', 'Pièce unique : une fois vendue, ce modèle ne revient pas.'],
}[STOCK] ?? [`Plus que ${STOCK} paires en stock`, 'Une seule paire par pointure : premier arrivé, premier servi.'];
$('scarcity-title').textContent = scarcity[0];
$('scarcity-text').textContent = scarcity[1];
$('scarcity').classList.toggle('is-out', !STOCK);

// ---------- Galerie ----------
const gallery = $('gallery');
gallery.replaceChildren(); // retire les squelettes du HTML
product.images.forEach((src, i) => {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'gallery__item sk';
  b.setAttribute('aria-label', `Agrandir la photo ${i + 1}`);
  b.innerHTML = `<img src="${imgUrl(src, 1000)}" alt="${escapeHtml(`${product.brand} ${product.name} – photo ${i + 1}`)}" ${i > 1 ? 'loading="lazy"' : ''}>`;
  b.addEventListener('click', () => openLightbox(i));
  revealOnLoad(b.querySelector('img'), b);
  gallery.append(b);

  const dot = document.createElement('span');
  dot.className = `gallery__dot${i ? '' : ' is-active'}`;
  $('gallery-dots').append(dot);
});
// Points du carrousel mobile
gallery.addEventListener('scroll', () => {
  const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
  $('gallery-dots').querySelectorAll('.gallery__dot').forEach((d, j) => d.classList.toggle('is-active', i === j));
}, { passive: true });

// ---------- Visionneuse ----------
let lbIndex = 0;
function showLightbox(i) {
  lbIndex = (i + product.images.length) % product.images.length;
  $('lb-img').src = imgUrl(product.images[lbIndex], 1600);
  $('lb-count').textContent = `${lbIndex + 1} / ${product.images.length}`;
}
function openLightbox(i) {
  showLightbox(i);
  $('lightbox').hidden = false;
  document.body.style.overflow = 'hidden';
}
function closeLightbox() {
  $('lightbox').hidden = true;
  document.body.style.overflow = '';
}
$('lb-close').addEventListener('click', closeLightbox);
$('lb-prev').addEventListener('click', () => showLightbox(lbIndex - 1));
$('lb-next').addEventListener('click', () => showLightbox(lbIndex + 1));
$('lightbox').addEventListener('click', (e) => { if (e.target.id === 'lightbox') closeLightbox(); });
document.addEventListener('keydown', (e) => {
  if ($('lightbox').hidden) return;
  if (e.key === 'Escape') closeLightbox();
  if (e.key === 'ArrowLeft') showLightbox(lbIndex - 1);
  if (e.key === 'ArrowRight') showLightbox(lbIndex + 1);
});

// ---------- Options (pointure, couleur…) ----------
// Une rangée par option. La pointure garde la grille complète en pastilles (épuisées barrées) ;
// les autres options s'affichent en boutons. Seules les combinaisons en stock sont sélectionnables.
const { sizeValue } = window.SBX;
const isNumeric = (vals) => vals.length > 0 && vals.every((v) => !Number.isNaN(sizeValue(v)));
const sizeIdx = OPTIONS.length ? OPTIONS.findIndex((o) => /pointure|taille|size/i.test(o.name) || isNumeric(o.values)) : -1;
const selection = OPTIONS.map(() => null);
// Une seule valeur possible, ou une seule variante en stock : déjà sélectionnée
OPTIONS.forEach((o, i) => { if (o.values.length === 1) selection[i] = o.values[0]; });
if (STOCK === 1) VARIANTS.find((v) => v.available).options.forEach((v, i) => { selection[i] = v; });

const variantFor = (sel) => VARIANTS.find((v) => sel.every((s, i) => s === v.options[i]));
const currentVariant = () => (OPTIONS.length ? (selection.every(Boolean) ? variantFor(selection) : null) : VARIANTS[0]);
const isAvailable = (i, value) => VARIANTS.some((v) => v.available && v.options[i] === value
  && selection.every((s, j) => j === i || !s || v.options[j] === s));
const optionLabel = (o, i) => (i === sizeIdx ? 'Pointure' : (/^(title|titre)$/i.test(o.name) ? 'Modèle' : o.name));
const valueLabel = (i, v) => (i === sizeIdx && isNumeric([v]) ? sizeLabel(v) : v);

const groupsEl = $('option-groups');
groupsEl.replaceChildren();
const groups = OPTIONS.map((o, i) => {
  const isSize = i === sizeIdx && isNumeric(o.values);
  const values = isSize
    ? [...new Set([...ALL_SIZES, ...o.values])].sort((a, b) => sizeValue(a) - sizeValue(b))
    : o.values;
  const group = document.createElement('div');
  group.className = 'pdp__option';
  group.innerHTML = `
    <div class="pdp__sizes-head">
      <p class="pdp__label">${escapeHtml(optionLabel(o, i))} <span data-selected></span></p>
      ${isSize ? '<button class="link" id="guide-open" type="button">Guide des tailles</button>' : ''}
    </div>
    <div class="pdp__sizes${isSize ? '' : ' pdp__sizes--text'}" role="radiogroup" aria-label="${escapeHtml(optionLabel(o, i))}"></div>`;
  const grid = group.querySelector('.pdp__sizes');
  grid.append(...values.map((v) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'pdp-size';
    b.textContent = valueLabel(i, v);
    b.dataset.value = v;
    b.setAttribute('role', 'radio');
    if (!o.values.includes(v)) b.dataset.absent = '';
    b.addEventListener('click', () => { selection[i] = selection[i] === v && OPTIONS.length > 1 ? null : v; renderOptions(); });
    return b;
  }));
  groupsEl.append(group);
  return { group, grid, index: i };
});
if (!OPTIONS.length && STOCK) {
  groupsEl.innerHTML = `<div class="pdp__option"><div class="pdp__sizes-head"><p class="pdp__label">Taille</p></div>
    <div class="pdp__sizes"><span class="pdp-size is-active">Taille unique</span></div></div>`;
}

function renderPrice(v) {
  const price = v?.price ?? product.price;
  const compare = v ? v.compareAt : product.compareAt;
  const promo = compare > price;
  $('price').textContent = fmt.format(price);
  $('price').classList.toggle('is-promo', promo);
  $('was').hidden = !promo;
  $('off').hidden = !promo;
  if (promo) {
    $('was').textContent = fmt.format(compare);
    $('off').textContent = `-${Math.round((1 - price / compare) * 100)}%`;
  }
  $('buybar-price').textContent = fmt.format(price);
}

function renderOptions() {
  groups.forEach(({ group, grid, index }) => {
    grid.querySelectorAll('.pdp-size[data-value]').forEach((b) => {
      const on = selection[index] === b.dataset.value;
      const ok = !('absent' in b.dataset) && isAvailable(index, b.dataset.value);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on);
      b.disabled = !ok && !on;
      b.title = ok || on ? '' : 'Épuisé';
    });
    const v = selection[index];
    group.querySelector('[data-selected]').textContent = v ? `: ${valueLabel(index, v)}` : '';
  });
  $('size-error').hidden = true;
  const v = currentVariant();
  // Variante choisie dans le formulaire Shopify (lu par les applications et sans JavaScript)
  $('sb-variant-id').disabled = false; // le sélecteur sans JavaScript (noscript) n'est pas utilisé
  if (v) $('sb-variant-id').value = v.id;
  renderPrice(v);
  renderAddButton();
}

// ---------- Panier Shopify et favoris ----------
function inCart() { const v = currentVariant(); return Boolean(v) && cart.variants.has(v.id); }
function renderAddButton() {
  if (!STOCK) return;
  const done = inCart();
  $('add').textContent = done ? 'Dans le panier ✓' : 'Ajouter au panier';
  [$('add'), $('buybar-add')].forEach((b) => b.classList.toggle('is-done', done));
}
async function addToCart() {
  if (!STOCK) return;
  const v = currentVariant();
  if (!v || !v.available) {
    const missing = OPTIONS.map((o, i) => (selection[i] ? null : optionLabel(o, i).toLowerCase())).filter(Boolean);
    $('size-error').textContent = missing.length ? `Choisis ta ${missing.join(' et ta ')} pour continuer` : 'Cette combinaison n’est plus disponible';
    $('size-error').hidden = false;
    groupsEl.classList.remove('shake');
    void groupsEl.offsetWidth; // relance l'animation
    groupsEl.classList.add('shake');
    groupsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  if (inCart()) return openPanel('cart');
  const buttons = [$('add'), $('buybar-add')];
  buttons.forEach((b) => { b.disabled = true; });
  try {
    await cart.add(v.id);
    const label = OPTIONS.map((o, i) => (i === sizeIdx ? `pointure ${valueLabel(i, selection[i])}` : selection[i])).join(' · ');
    toast(`Ajouté au panier${label ? ` · ${label}` : ''}`, { label: 'Voir', run: () => openPanel('cart') });
  } catch (err) {
    toast(err.message);
  } finally {
    buttons.forEach((b) => { b.disabled = false; });
    renderAddButton();
  }
}
document.addEventListener('sb:cartchange', renderAddButton);
renderOptions();
$('sb-product-form').addEventListener('submit', (e) => { e.preventDefault(); addToCart(); });
$('buybar-add').addEventListener('click', addToCart);
if (!STOCK) {
  [$('add'), $('buybar-add')].forEach((b) => { b.disabled = true; b.textContent = 'Épuisé'; });
}

$('wish').dataset.wish = product.handle;
syncWishButtons();
$('wish').addEventListener('click', () => {
  const on = toggleWish(product.handle);
  toast(on ? 'Ajouté à tes favoris' : 'Retiré de tes favoris', on ? { label: 'Voir', run: () => openPanel('wish') } : null);
});

// ---------- Livraison estimée (expédition 1 à 3 jours ouvrés + ~2 jours de transport) ----------
function addBusinessDays(date, n) {
  const d = new Date(date);
  while (n > 0) {
    d.setDate(d.getDate() + 1);
    if (d.getDay() !== 0 && d.getDay() !== 6) n--;
  }
  return d;
}
const dayFmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
$('eta-from').textContent = dayFmt.format(addBusinessDays(new Date(), 3));
$('eta-to').textContent = dayFmt.format(addBusinessDays(new Date(), 5));

// ---------- Onglets ----------
// Pas de description : on retire l'onglet et on affiche directement « Livraison & retours »
const noDescription = !$('tab-desc').textContent.trim() && !$('tab-desc').querySelector('img, iframe, video');
document.querySelectorAll('.tabs__btn').forEach((btn) => btn.addEventListener('click', () => {
  document.querySelectorAll('.tabs__btn').forEach((b) => {
    const on = b === btn;
    b.classList.toggle('is-active', on);
    b.setAttribute('aria-selected', on);
    $(b.getAttribute('aria-controls')).hidden = !on;
  });
}));
if (noDescription) {
  $('t-ship').click();
  $('t-desc').hidden = true;
  $('t-desc').nextElementSibling.hidden = true; // séparateur
  $('tab-desc').remove();
}

// ---------- Guide des tailles (indicatif, base Adidas) ----------
const GUIDE = [
  ['36', 3.5, 22.1], ['36 2/3', 4, 22.5], ['37 1/3', 4.5, 22.9], ['38', 5, 23.3], ['38 2/3', 5.5, 23.8],
  ['39 1/3', 6, 24.2], ['40', 6.5, 24.6], ['40 2/3', 7, 25], ['41 1/3', 7.5, 25.5], ['42', 8, 25.9],
  ['42 2/3', 8.5, 26.3], ['43 1/3', 9, 26.7], ['44', 9.5, 27.1], ['44 2/3', 10, 27.6], ['45 1/3', 10.5, 28], ['46', 11, 28.4],
];
$('guide-body').innerHTML = GUIDE.map(([eu, uk, cm]) =>
  `<tr><td>${eu}</td><td>${uk}</td><td>${uk + 0.5}</td><td>${uk + 1.5}</td><td>${String(cm).replace('.', ',')}</td></tr>`).join('');
$('guide-open')?.addEventListener('click', () => $('guide').showModal());
$('guide-close').addEventListener('click', () => $('guide').close());
$('guide').addEventListener('click', (e) => { if (e.target === $('guide')) $('guide').close(); });

// ---------- Contact et partage ----------
const digits = String(S.phone || '').replace(/[\s.-]/g, '');
$('help-phone').textContent = S.phone || '';
$('help-phone').href = `tel:${digits.startsWith('0') ? `+33${digits.slice(1)}` : digits}`;
$('help-mail').href = `mailto:${S.email}?subject=${encodeURIComponent(`Question : ${product.brand} ${product.name}`)}`;
// Mobile : feuille de partage native (menu Apple sur iPhone) ; ordinateur : copie du lien
$('share').addEventListener('click', async () => {
  const data = { title: `${titleCase(product.brand)} ${product.name}`, text: `${fmt.format(product.price)} sur SneakBoutik`, url: location.href };
  if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
    try { await navigator.share(data); } catch { /* partage annulé par l'utilisateur */ }
    return;
  }
  try {
    await navigator.clipboard.writeText(location.href);
    toast('Lien copié');
  } catch {
    prompt('Copie ce lien :', location.href);
  }
});

// ---------- Barre d'achat mobile ----------
$('buybar-name').textContent = `${titleCase(product.brand)} ${product.name}`;
new IntersectionObserver(([e]) => $('buybar').classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0))
  .observe($('add'));

// ---------- Suggestions : même marque d'abord, paires disponibles ----------
const related = ALL
  .filter((p) => p.handle !== product.handle && p.sizes.length)
  .sort((a, b) => (b.brand === product.brand) - (a.brand === product.brand))
  .slice(0, 4);
$('related')?.replaceChildren(...related.map(renderCard));

// ---------- Fin du chargement : on retire les squelettes ----------
$('pdp').classList.remove('is-loading');
$('pdp').removeAttribute('aria-busy');
};
window.SBX ? start() : document.addEventListener('sb:ready', start, { once: true });
})();
